import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant';
import 'vant/lib/index.css';
import request from './utils/request';//全局请求拦截器
import router from './router'//路由
import store from './store' //Vuex
import wxShare from './utils/wx-share'//微信分享
import wxLogin from './utils/wx-login'//微信登录
import wxPay from './utils/wx-pay' //微信支付
import wxLocation from './utils/wx-location' //微信定位
import VueWechatTitle from 'vue-wechat-title' //页面标题插件
import moment from 'moment'
Vue.use(VueWechatTitle)
Vue.use(Vant);
Vue.prototype.request = request
Vue.prototype.$wxShare = wxShare
Vue.prototype.$wxLogin = wxLogin
Vue.prototype.$wxPay = wxPay
Vue.prototype.$wxLocation = wxLocation
import { Lazyload } from 'vant';
Vue.use(Lazyload);
Vue.filter('formonment',function(v,pattern){ 
  return  moment(v).format(pattern)
})
Vue.config.productionTip = false





new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
